<div class="actionbar">
  <button
    (click)="clickReport('action_orders_to_invoices', 'json')"
    [disabled]="isProcessing || !ids.length"
  >
    Erstelle Rechnungen
  </button>
  <button
    (click)="clickReport('pdf_invoices')"
    [disabled]="isProcessing || !ids.length"
  >
    Rechnungen drucken
  </button>
  <button
    (click)="clickReport('pdf_orders')"
    [disabled]="isProcessing || !ids.length"
  >
    Lieferscheine drucken
  </button>
  <button
    (click)="clickReport('orders_by_product')"
    [disabled]="isProcessing || !ids.length"
  >
    Excel Produktliste
  </button>
  <button
    (click)="clickReport('orders_by_customer')"
    [disabled]="isProcessing || !ids.length"
  >
    Excel Kundenliste
  </button>
  <span class="status" *ngIf="isProcessing">Export wird vorbereitet...</span>
</div>
<div *ngIf="exports$ | async as exports">
  <div *ngFor="let e of exports">
    <input
      type="checkbox"
      [checked]="isSelected(e.id)"
      (change)="select(e.id, $event)"
      value="{{ e.id }}"
    />ExportSet Id{{ e.id }} - {{ e.type }}
    <div class="lines">
      <span class="line" *ngFor="let l of e.lines"
        >{{ l.lineable_type }}:&nbsp;{{ l.lineable_id }}
      </span>
    </div>
    <span class="actions"
      ><button (click)="clickAdd(e.id)" mat-raised-button>
        <mat-icon fontIcon="">add_circle</mat-icon>
      </button></span
    >
  </div>
</div>
